import React from "react";
import contextProvider from "../../contextProvider";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { NavLink as RouterNavLink } from "react-router-dom";
import classnames from "classnames";

import _ReactOBaseComponent, {
  withDefinedContext,
} from "../../_L0_components/_ReactOBaseComponent";

const context_exposed_methods = ["toggle"];

class ReactOTabs extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      cursor: 0,
    };
    super(props, initState);
  }

  //
  //	Lifecycle methods
  //

  onComponentDidMount() {
    this.definePromptingFunction({
      name: "toggle",
      func: (new_cursor) => {
        this.setState({
          cursor: new_cursor,
        });
      },
    });
    if (this.props.subroutesNavigator) {
      if (
        !this.props.tabs
          .filter((value) => {
            return value !== undefined;
          })
          .find((value) => {
            return new RegExp(
              "^" + this.getAppContext().router.location.pathname + "$"
            ).test(value.to);
          })
      ) {
        this.getAppContext().redirectTo(this.props.tabs[0].to, true);
      }
    }
  }

  onComponentWillUnmount() {}

  onGetChildContext() {
    return {};
  }

  onRender() {
    return (
      <span>
        <Nav tabs>
          {(this.props.tabs ? this.props.tabs : [])
            .filter((value) => {
              return value !== undefined;
            })
            .map((_CURR_tab, _CURR_idx) => {
              let _tabButton = this.props.subroutesNavigator ? (
                <RouterNavLink
                  className={
                    "nav-link " +
                    (!this.props.subroutesNavigator
                      ? classnames({ active: this.state.cursor === _CURR_idx })
                      : "")
                  }
                  {...(this.props.subroutesNavigator && _CURR_tab.to
                    ? { to: _CURR_tab.to }
                    : {
                        onClick: () => {
                          this.toggle(_CURR_idx);
                        },
                      })}
                  exact={true}
                >
                  {_CURR_tab.title}
                </RouterNavLink>
              ) : (
                <NavLink
                  className={
                    "nav-link " +
                    (!this.props.subroutesNavigator
                      ? classnames({ active: this.state.cursor === _CURR_idx })
                      : "")
                  }
                  //							color={this.state.cursor === _CURR_idx ? 'primary' : 'light'}
                  onClick={() => {
                    this.toggle(_CURR_idx);
                  }}
                >
                  {_CURR_tab.title}
                </NavLink>
              );
              return (
                <NavItem
                  key={_CURR_idx}
                  className={_CURR_tab.align ? "align-" + _CURR_tab.align : ""}
                >
                  {_tabButton}
                </NavItem>
              );
            })}

          {/*React.Children.map(this.props.children, (_CURR_child, _CURR_idx) => {
						return (
							
						);
					})*/}
        </Nav>
        {this.props.subroutesNavigator ? (
          this.props.children
        ) : (
          <TabContent activeTab={this.state.cursor}>
            {React.Children.map(this.props.children, (_CURR_child, _CURR_idx) => {
              return (
                <TabPane tabId={_CURR_idx}>{React.cloneElement(_CURR_child, {})}</TabPane>
              );
            })}
          </TabContent>
        )}
      </span>
    );
  }
}

export default contextProvider(
  withDefinedContext(ReactOTabs, "ReactOTabs", context_exposed_methods, true),
  {
    retrieve: null,
  }
);
